import { render, staticRenderFns } from "./EcommerceProfessionnels.vue?vue&type=template&id=055912b4&"
import script from "./EcommerceProfessionnels.vue?vue&type=script&lang=js&"
export * from "./EcommerceProfessionnels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports